import locationService from '../../../services/locationService';
import {
  invalidateTokens,
  getSignoutUrl,
} from '../../../services/security/userAuthService';
import projectTokenCache from '../../../services/security/projectTokenCache';

export const logOutThunk = () => async () => {
  await invalidateTokens();
  const signoutUrl = await getSignoutUrl();
  projectTokenCache.reset();
  // eslint-disable-next-line no-console
  console.log('redirecting to logout');
  // eslint-disable-next-line no-console
  console.log('singout', signoutUrl);
  locationService.redirect(signoutUrl);
};
